export default "__VITE_ASSET__d2R4LVlh__"